import { finalsScenario } from "./finals.ts";
import { regularSeasonScenario } from "./regular-season.ts";
import { summerLeagueScenario } from "./summer-league.ts";
export const scenarios = [
    summerLeagueScenario,
    finalsScenario,
    regularSeasonScenario
];
export function requireScenario(gameId) {
    const scenario = scenarios.find((candidate) => candidate.id === gameId);
    if (!scenario) {
        throw new Error(`Missing game scenario: ${gameId}`);
    }
    return scenario;
}
export function requireScenarioAsset(gameId, assetId) {
    const scenario = requireScenario(gameId);
    const asset = scenario.feedAssets.find((candidate) => candidate.id === assetId);
    if (!asset) {
        throw new Error(`Missing feed asset ${assetId} for game ${gameId}`);
    }
    return asset;
}
